import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { Box } from '@material-ui/core'

import {
  MdInsertChart,
  MdConstruction,
  MdEco,
  MdStar,
  MdDashboard,
  MdTimeline,
  MdTaskAlt,
  MdOutlineIntegrationInstructions,
  MdAccessibleForward,
  MdRecycling,
  MdEnergySavingsLeaf,
  MdElectricBike,
  MdMuseum,
  MdOutlineArchitecture,
  MdLocalActivity,
  MdHearing,
  MdOutlineAttachMoney,
  MdApartment
} from 'react-icons/md'
import {
  GiStairsGoal,
  GiModernCity,
  GiCityCar,
  GiFactory,
  GiParkBench,
  GiTreehouse,
  GiFountain,
  GiBridge,
  GiCastle,
  GiStreetLight,
  GiSolarPower,
  GiWindTurbine,
  GiWaterDrop,
  GiEarthAmerica,
  GiTreeRoots,
  GiElectric,
  GiMedal,
  GiPodiumWinner,
  GiCompass,
  GiPencil,
  GiCrane,
  GiCog,
  GiSettingsKnobs,
  GiWalkingBoot,
  GiCampfire,
  GiFarmTractor,
  GiCactus,
  GiStoneWall,
  GiChurch,
  GiArchBridge,
  GiAncientRuins,
  GiMonumentValley,
  GiSundial,
  GiStonePile,
  GiTempleGate,
  GiIsland,
  GiVolcano,
  GiWaveCrest,
  GiForest,
  GiDesert,
  GiGrass,
  GiPineTree,
  GiWaterfall,
  GiSunflower,
  GiPerspectiveDiceSixFacesRandom,
  GiStairs,
  GiRoad,
  GiBusStop,
  GiAirplane,
  GiSailboat,
  GiCarWheel,
  GiLeafSkeleton,
  GiHammerNails,
  GiLifeBuoy,
  GiDoubleStreetLights,
  GiDirectionSigns,
  GiStopSign,
  GiGroundSprout,
  GiColombianStatue,
  GiMountaintop,
  GiTrafficLightsGreen
} from 'react-icons/gi'
import { HiOutlineLightBulb } from 'react-icons/hi'
import {
  BsFillPeopleFill,
  BsBarChartSteps,
  BsSignTurnLeftFill,
  BsFillHousesFill
} from 'react-icons/bs'
import {
  AiOutlineCheckCircle,
  AiOutlineCrown,
  AiOutlineSchedule
} from 'react-icons/ai'
import {
  FaParking,
  FaBorderNone,
  FaTrophy,
  FaUsers,
  FaCertificate,
  FaUniversalAccess,
  FaWheelchair,
  FaHandsHelping,
  FaCampground,
  FaMountain,
  FaTrain,
  FaWalking
} from 'react-icons/fa'
import {
  FaTrainTram,
  FaTrainSubway,
  FaUsersGear,
  FaPeopleGroup,
  FaHouseChimney
} from 'react-icons/fa6'
import {
  TbProgressCheck,
  TbDisabled,
  TbLayout,
  TbCane,
  TbPlayFootball,
  TbPyramid
} from 'react-icons/tb'
import { FiFlag, FiEye, FiGrid } from 'react-icons/fi'
import { GrCheckbox } from 'react-icons/gr'
import { PiTrafficSignFill, PiTrafficSignalFill, PiMoney } from 'react-icons/pi'
import {
  TbBuildingSkyscraper,
  TbRulerMeasure,
  TbPicnicTable
} from 'react-icons/tb'
import { LuTrafficCone } from 'react-icons/lu'
import { SiBlueprint, SiBlockbench } from 'react-icons/si'
import { RiFlowChart } from 'react-icons/ri'
import { IoIosBicycle } from 'react-icons/io'
import { RxSpaceEvenlyVertically } from 'react-icons/rx'

export const icons = {
  FaHouseChimney,
  MdInsertChart,
  GiStairsGoal,
  AiOutlineCheckCircle,
  HiOutlineLightBulb,
  BsFillPeopleFill,
  BsBarChartSteps,
  GiModernCity,
  GiCityCar,
  GiFactory,
  GiParkBench,
  GiTreehouse,
  GiFountain,
  GiBridge,
  GiCastle,
  GiStreetLight,
  GiSolarPower,
  GiWindTurbine,
  GiWaterDrop,
  GiEarthAmerica,
  GiTreeRoots,
  GiElectric,
  MdConstruction,
  FaParking,
  MdEco,
  FaUsersGear,
  TbProgressCheck,
  GrCheckbox,
  FaPeopleGroup,
  PiTrafficSignFill,
  FaBorderNone,
  FaTrophy,
  FaUsers,
  FiFlag,
  FaCertificate,
  AiOutlineCrown,
  MdStar,
  GiMedal,
  GiPodiumWinner,
  GiCompass,
  GiPencil,
  GiCrane,
  GiCog,
  GiSettingsKnobs,
  FaUniversalAccess,
  FiEye,
  MdAccessibleForward,
  TbDisabled,
  GiWalkingBoot,
  GiCampfire,
  GiFarmTractor,
  GiCactus,
  GiStoneWall,
  GiChurch,
  GiArchBridge,
  GiAncientRuins,
  GiMonumentValley,
  GiSundial,
  GiStonePile,
  GiTempleGate,
  GiIsland,
  GiVolcano,
  GiWaveCrest,
  GiForest,
  GiDesert,
  GiGrass,
  GiPineTree,
  GiWaterfall,
  GiSunflower,
  MdDashboard,
  TbLayout,
  GiPerspectiveDiceSixFacesRandom,
  FiGrid,
  MdTimeline,
  MdTaskAlt,
  AiOutlineSchedule,
  GiStairs,
  MdOutlineIntegrationInstructions,
  GiRoad,
  GiBusStop,
  GiAirplane,
  GiSailboat,
  GiCarWheel,
  TbBuildingSkyscraper,
  MdRecycling,
  GiLeafSkeleton,
  MdEnergySavingsLeaf,
  TbRulerMeasure,
  LuTrafficCone,
  GiHammerNails,
  SiBlueprint,
  FaWheelchair,
  GiLifeBuoy,
  TbCane,
  FaHandsHelping,
  TbPicnicTable,
  SiBlockbench,
  GiDoubleStreetLights,
  GiDirectionSigns,
  GiStopSign,
  BsSignTurnLeftFill,
  PiTrafficSignalFill,
  TbPlayFootball,
  GiGroundSprout,
  FaCampground,
  MdElectricBike,
  TbPyramid,
  MdMuseum,
  GiColombianStatue,
  GiMountaintop,
  FaMountain,
  RiFlowChart,
  GiTrafficLightsGreen,
  FaTrain,
  FaTrainTram,
  FaTrainSubway,
  IoIosBicycle,
  FaWalking,
  RxSpaceEvenlyVertically,
  MdOutlineArchitecture,
  MdLocalActivity,
  MdHearing,
  MdOutlineAttachMoney,
  PiMoney,
  BsFillHousesFill,
  MdApartment
}

const iconOptions = [
  {
    label: 'MdApartment',
    value: 'MdApartment'
  },
  {
    label: 'BsFillHousesFill',
    value: 'BsFillHousesFill'
  },
  {
    label: 'FaHouseChimney',
    value: 'FaHouseChimney'
  },
  {
    label: 'PiMoney',
    value: 'PiMoney'
  },
  {
    label: 'MdOutlineAttachMoney',
    value: 'MdOutlineAttachMoney'
  },
  {
    label: 'MdHearing',
    value: 'MdHearing'
  },
  {
    label: 'MdLocalActivity',
    value: 'MdLocalActivity'
  },
  {
    label: 'MdOutlineArchitecture',
    value: 'MdOutlineArchitecture'
  },
  {
    label: 'RxSpaceEvenlyVertically',
    value: 'RxSpaceEvenlyVertically'
  },
  {
    label: 'FaWalking',
    value: 'FaWalking'
  },
  {
    label: 'IoIosBicycle',
    value: 'IoIosBicycle'
  },
  {
    label: 'FaTrainSubway',
    value: 'FaTrainSubway'
  },
  {
    label: 'FaTrainTram',
    value: 'FaTrainTram'
  },
  {
    label: 'FaTrain',
    value: 'FaTrain'
  },
  {
    label: 'GiTrafficLightsGreen',
    value: 'GiTrafficLightsGreen'
  },
  {
    label: 'RiFlowChart',
    value: 'RiFlowChart'
  },
  {
    label: 'FaMountain',
    value: 'FaMountain'
  },
  {
    label: 'GiMountaintop',
    value: 'GiMountaintop'
  },
  {
    label: 'GiColombianStatue',
    value: 'GiColombianStatue'
  },
  {
    label: 'MdMuseum',
    value: 'MdMuseum'
  },
  {
    label: 'TbPyramid',
    value: 'TbPyramid'
  },
  {
    label: 'MdElectricBike',
    value: 'MdElectricBike'
  },
  {
    label: 'FaCampground',
    value: 'FaCampground'
  },
  {
    label: 'GiGroundSprout',
    value: 'GiGroundSprout'
  },
  {
    label: 'TbPlayFootball',
    value: 'TbPlayFootball'
  },
  {
    label: 'PiTrafficSignalFill',
    value: 'PiTrafficSignalFill'
  },
  {
    label: 'BsSignTurnLeftFill',
    value: 'BsSignTurnLeftFill'
  },
  {
    label: 'GiStopSign',
    value: 'GiStopSign'
  },
  {
    label: 'GiDirectionSigns',
    value: 'GiDirectionSigns'
  },
  {
    label: 'GiDoubleStreetLights',
    value: 'GiDoubleStreetLights'
  },
  {
    label: 'SiBlockbench',
    value: 'SiBlockbench'
  },
  {
    label: 'TbPicnicTable',
    value: 'TbPicnicTable'
  },
  {
    label: 'FaHandsHelping',
    value: 'FaHandsHelping'
  },
  {
    label: 'TbCane',
    value: 'TbCane'
  },
  {
    label: 'GiLifeBuoy',
    value: 'GiLifeBuoy'
  },
  {
    label: 'FaWheelchair',
    value: 'FaWheelchair'
  },
  {
    label: 'SiBlueprint',
    value: 'SiBlueprint'
  },
  {
    label: 'GiHammerNails',
    value: 'GiHammerNails'
  },
  {
    label: 'LuTrafficCone',
    value: 'LuTrafficCone'
  },
  {
    label: 'TbRulerMeasure',
    value: 'TbRulerMeasure'
  },
  {
    label: 'MdEnergySavingsLeaf',
    value: 'MdEnergySavingsLeaf'
  },
  {
    label: 'GiLeafSkeleton',
    value: 'GiLeafSkeleton'
  },
  {
    label: 'MdRecycling',
    value: 'MdRecycling'
  },
  {
    label: 'TbBuildingSkyscraper',
    value: 'TbBuildingSkyscraper'
  },
  {
    label: 'GiElectric',
    value: 'GiElectric'
  },
  {
    label: 'GiTreeRoots',
    value: 'GiTreeRoots'
  },
  {
    label: 'GiEarthAmerica',
    value: 'GiEarthAmerica'
  },
  {
    label: 'GiWaterDrop',
    value: 'GiWaterDrop'
  },
  {
    label: 'GiWindTurbine',
    value: 'GiWindTurbine'
  },
  {
    label: 'GiSolarPower',
    value: 'GiSolarPower'
  },
  {
    label: 'GiStreetLight',
    value: 'GiStreetLight'
  },
  {
    label: 'GiCastle',
    value: 'GiCastle'
  },
  {
    label: 'GiBridge',
    value: 'GiBridge'
  },
  {
    label: 'GiFountain',
    value: 'GiFountain'
  },
  {
    label: 'GiTreehouse',
    value: 'GiTreehouse'
  },
  {
    label: 'GiParkBench',
    value: 'GiParkBench'
  },
  {
    label: 'GiFactory',
    value: 'GiFactory'
  },
  {
    label: 'GiCityCar',
    value: 'GiCityCar'
  },
  {
    label: 'MdInsertChart',
    value: 'MdInsertChart'
  },
  {
    label: 'GiStairsGoal',
    value: 'GiStairsGoal'
  },
  {
    label: 'AiOutlineCheckCircle',
    value: 'AiOutlineCheckCircle'
  },
  {
    label: 'HiOutlineLightBulb',
    value: 'HiOutlineLightBulb'
  },
  {
    label: 'BsFillPeopleFill',
    value: 'BsFillPeopleFill'
  },
  {
    label: 'BsBarChartSteps',
    value: 'BsBarChartSteps'
  },
  {
    label: 'GiModernCity',
    value: 'GiModernCity'
  },
  {
    label: 'MdConstruction',
    value: 'MdConstruction'
  },
  {
    label: 'FaParking',
    value: 'FaParking'
  },
  {
    label: 'MdEco',
    value: 'MdEco'
  },
  {
    label: 'FaUsersGear',
    value: 'FaUsersGear'
  },
  {
    label: 'TbProgressCheck',
    value: 'TbProgressCheck'
  },
  {
    label: 'GrCheckbox',
    value: 'GrCheckbox'
  },
  {
    label: 'FaPeopleGroup',
    value: 'FaPeopleGroup'
  },
  {
    label: 'PiTrafficSignFill',
    value: 'PiTrafficSignFill'
  },
  {
    label: 'FaBorderNone',
    value: 'FaBorderNone'
  },
  {
    label: 'FaTrophy',
    value: 'FaTrophy'
  },
  {
    label: 'FaUsers',
    value: 'FaUsers'
  },
  {
    label: 'FiFlag',
    value: 'FiFlag'
  },
  {
    label: 'FaCertificate',
    value: 'FaCertificate'
  },
  {
    label: 'AiOutlineCrown',
    value: 'AiOutlineCrown'
  },
  {
    label: 'MdStar',
    value: 'MdStar'
  },
  {
    label: 'GiMedal',
    value: 'GiMedal'
  },
  {
    label: 'GiPodiumWinner',
    value: 'GiPodiumWinner'
  },
  {
    label: 'GiCompass',
    value: 'GiCompass'
  },
  {
    label: 'GiPencil',
    value: 'GiPencil'
  },
  {
    label: 'GiCrane',
    value: 'GiCrane'
  },
  {
    label: 'GiCog',
    value: 'GiCog'
  },
  {
    label: 'GiSettingsKnobs',
    value: 'GiSettingsKnobs'
  },
  {
    label: 'FaUniversalAccess',
    value: 'FaUniversalAccess'
  },
  {
    label: 'FiEye',
    value: 'FiEye'
  },
  {
    label: 'MdAccessibleForward',
    value: 'MdAccessibleForward'
  },
  {
    label: 'TbDisabled',
    value: 'TbDisabled'
  },
  {
    label: 'GiWalkingBoot',
    value: 'GiWalkingBoot'
  },
  {
    label: 'GiCampfire',
    value: 'GiCampfire'
  },
  {
    label: 'GiFarmTractor',
    value: 'GiFarmTractor'
  },
  {
    label: 'GiCactus',
    value: 'GiCactus'
  },
  {
    label: 'GiStoneWall',
    value: 'GiStoneWall'
  },
  {
    label: 'GiChurch',
    value: 'GiChurch'
  },
  {
    label: 'GiArchBridge',
    value: 'GiArchBridge'
  },
  {
    label: 'GiAncientRuins',
    value: 'GiAncientRuins'
  },
  {
    label: 'GiMonumentValley',
    value: 'GiMonumentValley'
  },
  {
    label: 'GiSundial',
    value: 'GiSundial'
  },
  {
    label: 'GiStonePile',
    value: 'GiStonePile'
  },
  {
    label: 'GiTempleGate',
    value: 'GiTempleGate'
  },
  {
    label: 'GiIsland',
    value: 'GiIsland'
  },
  {
    label: 'GiVolcano',
    value: 'GiVolcano'
  },
  {
    label: 'GiWaveCrest',
    value: 'GiWaveCrest'
  },
  {
    label: 'GiForest',
    value: 'GiForest'
  },
  {
    label: 'GiDesert',
    value: 'GiDesert'
  },
  {
    label: 'GiGrass',
    value: 'GiGrass'
  },
  {
    label: 'GiPineTree',
    value: 'GiPineTree'
  },
  {
    label: 'GiWaterfall',
    value: 'GiWaterfall'
  },
  {
    label: 'GiSunflower',
    value: 'GiSunflower'
  },
  {
    label: 'MdDashboard',
    value: 'MdDashboard'
  },
  {
    label: 'TbLayout',
    value: 'TbLayout'
  },
  {
    label: 'GiPerspectiveDiceSixFacesRandom',
    value: 'GiPerspectiveDiceSixFacesRandom'
  },
  {
    label: 'FiGrid',
    value: 'FiGrid'
  },
  {
    label: 'MdTimeline',
    value: 'MdTimeline'
  },
  {
    label: 'MdTaskAlt',
    value: 'MdTaskAlt'
  },
  {
    label: 'AiOutlineSchedule',
    value: 'AiOutlineSchedule'
  },
  {
    label: 'GiStairs',
    value: 'GiStairs'
  },
  {
    label: 'MdOutlineIntegrationInstructions',
    value: 'MdOutlineIntegrationInstructions'
  },
  {
    label: 'GiRoad',
    value: 'GiRoad'
  },
  {
    label: 'GiBusStop',
    value: 'GiBusStop'
  },
  {
    label: 'GiAirplane',
    value: 'GiAirplane'
  },
  {
    label: 'GiSailboat',
    value: 'GiSailboat'
  },
  {
    label: 'GiCarWheel',
    value: 'GiCarWheel'
  }
]

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
    width: '100%'
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  menuItem: {
    margin: '4px 8px',
    padding: '4px 8px'
  }
}))

export default function RatingCriteriaIconOptions({
  criteriaItemIcon,
  handleChangeIcon
}) {
  const classes = useStyles()

  const renderIcon = iconName => {
    const Icon = icons[iconName]
    const iconProps = { style: { width: 23, height: 23 } }
    return <Icon {...iconProps} />
  }

  return (
    <FormControl className={classes.formControl}>
      <Select
        labelId="select-icon-for-rating-criteria"
        id="select-icon-for-rating-criteria"
        value={criteriaItemIcon}
        onChange={handleChangeIcon}
      >
        {iconOptions.map(option => (
          <MenuItem
            disableGutters={true}
            key={option.value}
            value={option.value}
            classes={{
              root: classes.menuItem
            }}
          >
            <Box display="flex" alignItems="center">
              {renderIcon(option.value)}
              <Box ml={2}>{option.label}</Box>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
